<div class="col-12 col-md-4 mx-auto text-center">
  <div class="container p-0">
    <section class="jumbotron-home pointer" (click)="goToPage('auth')"></section>
  </div>
</div>

